

const getDomEl = (elId, returnArray) => {
  const elms = document.querySelectorAll(elId);
  if(returnArray) return elms;
  if (elms.length === 1) return elms[0];
  if (elms.length > 1) return elms;
  else return null;
};

export default getDomEl;